import axiosServices from "../utils/axios";

import type { PhoneResponce } from "../utils/types/type-helper";

interface FetchApiResponce {
  data: any[];
}

export const fetchPhoneList = async () => {
  const response = await axiosServices.get<FetchApiResponce>("/phone");
  return response.data;
};

export const filterUsedPhones = (phoneList: any[], jobId: string): any[] =>
  phoneList
    .filter((phone) => !phone.job_id || phone.job_id === jobId)
    .sort((a, b) => a.name.localeCompare(b.name));

export const addPhone = async (payload: PhoneResponce) => {
  const response = await axiosServices.post("/phone", payload);
  return response.data;
};

export const updatePhone = async (
  phone_id: string,
  data: {
    [key: string]: any;
    phone_id: string;
  }
) => {
  await axiosServices.put(`/phone/${phone_id}`, data);
  return {
    success: true,
    data,
  };
};

export const deletePhone = async (phone_id: string) => {
  const response = await axiosServices.delete(`/phone/${phone_id}`);
  return response.data;
};

export const updatePhoneClient = async (
  phoneId: string,
  clientId: string,
  oldClientId: string
) => {
  if (oldClientId)
    await axiosServices.put(`/jobs/${oldClientId}`, {
      assigned_phone_id: null,
    });
  if (!clientId) return { success: true };
  const response = await axiosServices.put(`/jobs/${clientId}`, {
    assigned_phone_id: phoneId,
  });
  return response.data;
};
